import { useState, useEffect } from "react";
import { useStyles } from "./modalContent";

const ReusableComprehensiveCarePlanModal = ({
  isOpen,
  onClose,
  mode,
  providerData,
  onSubmit,
  onDelete,
}) => {
  const classes = useStyles();

  // Initialize formData based on providerData for edit/create modes
  const [formData, setFormData] = useState({
    name: providerData?.name || "",
    tests: JSON.stringify(providerData?.value || {}, null, 2), // Pretty-printed JSON
  });
  const [error, setError] = useState(null);

  // Update formData when providerData changes
  useEffect(() => {
    setFormData({
      name: providerData?.name || "",
      tests: JSON.stringify(providerData?.value || {}, null, 2),
    });
  }, [providerData]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!formData.name || !formData.tests) {
      setError("Name and Tests are required.");
      return false;
    }
    try {
      JSON.parse(formData.tests); // Ensure tests is valid JSON
    } catch (err) {
      setError("Tests must be valid JSON.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    setError(null);
    if ((mode === "edit" || mode === "create") && !validateForm()) return;

    try {
      const payload = {
        name: formData.name,
        value: JSON.parse(formData.tests),
      };

      if (mode === "edit") {
        await onSubmit(providerData.id, payload);
      } else if (mode === "create") {
        await onSubmit(null, payload);
      } else if (mode === "delete") {
        await onDelete(providerData.id);
      }
      onClose();
    } catch (err) {
      setError("Operation failed. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "500px",
          boxShadow: "0 8px 10px rgba(0, 0, 0, 0.1)",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <h2>
          {mode === "view"
            ? "View Comprehensive Care Plan"
            : mode === "edit"
            ? "Edit Comprehensive Care Plan"
            : mode === "create"
            ? "Create Comprehensive Care Plan"
            : "Delete Comprehensive Care Plan"}
        </h2>
        {error && <p style={{ color: "red" }}>{error}</p>}

        {mode === "view" && (
          <div>
            <p>
              <strong>Plan Name:</strong> {providerData?.name || "N/A"}
            </p>
            <p>
              <strong>Tests:</strong>
            </p>
            {Object.entries(providerData?.value || {}).length > 0 ? (
              <ul style={{ paddingLeft: "20px" }}>
                {Object.entries(providerData?.value).map(
                  ([test, codes], index) => (
                    <li key={index}>
                      {test}: {codes.join(", ")}
                    </li>
                  )
                )}
              </ul>
            ) : (
              <p>No tests available.</p>
            )}
          </div>
        )}

        {(mode === "edit" || mode === "create") && (
          <form>
            <div>
              <label className={classes.enroleeIdText}>Plan Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              />
            </div>
            <div>
              <label className={classes.enroleeIdText}>
                Tests (JSON format):
              </label>
              <textarea
                name="tests"
                value={formData.tests}
                onChange={handleChange}
                className={classes.enroleeInputId}
                rows={10}
                style={{ width: "100%", resize: "vertical" }}
                placeholder='e.g., {"Test Name": ["code1", "code2"]}'
                required
              />
            </div>
          </form>
        )}

        {mode === "delete" && (
          <p>
            Are you sure you want to delete the {providerData?.name}{" "}
            comprehensive care plan?
          </p>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "#ccc",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {mode === "view" ? "Close" : "Cancel"}
          </button>
          {(mode === "edit" || mode === "create" || mode === "delete") && (
            <button
              onClick={handleSubmit}
              style={{
                padding: "8px 16px",
                background: mode === "delete" ? "#d32f2f" : "#1976d2",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              {mode === "edit"
                ? "Save"
                : mode === "create"
                ? "Create"
                : "Delete"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReusableComprehensiveCarePlanModal;
